import { render, staticRenderFns } from "./CoachingProfileDetails.vue?vue&type=template&id=5396dd66"
import script from "./CoachingProfileDetails.vue?vue&type=script&lang=js"
export * from "./CoachingProfileDetails.vue?vue&type=script&lang=js"
import style0 from "./CoachingProfileDetails.vue?vue&type=style&index=0&id=5396dd66&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports